<template>
  <div class="exchange-i">
    <div data-v-af5d225e="" data-v-9db5dd14="" class="header" @click="goBack()">
      <div data-v-af5d225e="">
        <i data-v-af5d225e="" class="back">
          </i> <h3 data-v-af5d225e="">指导内容</h3>
          </div>
   </div>
    <div class="list-head" >
      <div>
        <p>学生学号：{{designReCodeList.studentnumber?designReCodeList.studentnumber:''}}</p>
        <p>学生姓名：{{designReCodeList.studentname?designReCodeList.studentname:''}}</p>
        <p>设计（论文）题目：{{designReCodeList.topicname?designReCodeList.topicname:''}}</p>
      </div>
             
      </div>
    <div class="exchange">
      <div>
        <textarea ref="textarea"  class="textarea" v-html="msg" v-model="msg"></textarea>
      </div>  
    </div>
    <div class="bottom-btn">
      <button @click="toSubmitGuide">提交</button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      designReCodeList: {},
      msg:'',
      msgContext:""
    };
  },
  methods: {
    async loadZdmsgDeal(){
      const params = {
        ywstid: this.$route.query.ywstid,
      };
      const res = await Api.loadZdmsgDeal(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
        this.msg = res.data.responsecontext.replace(/<br>/g,'\r\n');
      }
    },
    async toSubmitGuide(){
      if(this.msg==''){
        this.$toast.fail("指导内容不能为空！");
        return false;
      }
      const params = {
        ywstid: this.$route.query.ywstid,
        guidContext:this.msg,
      };
      const res = await Api.saveGuidContext(params);
      if(res.code=='1'){
        this.$toast.success("提交成功!");
        setTimeout(() => {
          this.$router.replace("/design");
        }, 1500);
      }
    },
    goBack(){
      //localStorage
      localStorage.setItem(this.$route.query.ywstid,this.msg);
      this.$router.push({
          path: "/design/guideDeal",
          query: {
            ywstid: this.$route.query.ywstid,
          }
        });
   }     
  },
  created() {
    if(localStorage.getItem(this.$route.query.ywstid)){
      this.msg = localStorage.getItem(this.$route.query.ywstid);
    }else{
      this.loadZdmsgDeal();
    }
    
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 100px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding-left: 6%;
      padding-top: 2%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      }
    }
  .exchange {
    padding: 5% 5% 0;
    
    height: 70vh;
    p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
     div{
      box-sizing: border-box;
      background-color: #f8f8f8;
      border-radius: 8px;
      height: 65vh;
      word-wrap: break-word;
      overflow:auto;
      padding: 5px 5px;
     }

     textarea{
      height: 65vh;
      overflow:auto;
      width: 100%;
      white-space: pre-wrap;
      word-break:break-all;
     }

  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Design/doGuideRequst.vue